<template lang="pug">
  sw-radio(
    :checked-radio-classes="checkedRadioClasses"
    :custom-classes="customClasses"
    :radio-classes="radioClasses"
    v-bind="{...$props, ...$attrs}"
    v-on="$listeners"
  )
    span(:class="labelClasses") {{ label }}
</template>
<script>
import SwRadio from '../generic/SwRadio';

export default {
  name: 'ProfilingRadio',
  components: {
    SwRadio,
  },
  props: {
    value: {
      type: [String, Boolean, Number],
      default: null,
    },
    radioValue: {
      type: [String, Boolean, Number],
      default: null,
    },
    error: {
      type: Boolean,
      default: false,
    },
    label: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    active () {
      return this.value === this.radioValue;
    },
    mainClasses () {
      return 'rounded cursor-pointer border md:border-2 flex items-center pr-12 text-gray-700 py-4 pl-4 mb-4 hover:bg-white focus:outline-none focus:shadow-outline';
    },
    statusClasses () {
      if (this.error) return 'border-red-500 bg-red-100 hover:text-red-500';
      if (this.active) return 'border-green-900 bg-green-150 hover:text-green-900 focus:text-gray-700';
      return 'border-gray-300 bg-white hover:border-green-900 hover:text-green-900 focus:text-gray-700';
    },
    customClasses () {
      return `${this.mainClasses} ${this.statusClasses}`;
    },
    radioClasses () {
      return `w-6 h-6 p-3 rounded-full border flex items-center justify-center ${this.active ? 'border-green-900' : 'border-gray-300'}`;
    },
    checkedRadioClasses () {
      return 'w-4 h-4 p-2 rounded-full checked:bg-green-900';
    },
    labelClasses () {
      return 'ml-4 text-base font-medium leading-tight md:leading-normal md:text-xl';
    },
  },
};
</script>
